<template>
    <div class="row">
        <div class="col-6">
            <textarea @paste="handlePaste" placeholder="Input here, try paste any thing"></textarea>
        </div>
        <div class="col-6">
            <textarea readonly placeholder="Output here">{{ pasteData }}</textarea>
        </div>
    </div>
</template>
<style scoped>
textarea {
    height: 425px;
    width: 100%;
    border-color: #000000BF;
    border-width: thick;
    border-style: solid;
    resize: none;
}
</style>
<script>
export default {
    data() {
        return {
            pasteData: {
                prototype: undefined,
                items: undefined
            }
        };
    },
    methods: {
        handlePaste(event) {
            this.$data.pasteData = {
                prototype: undefined,
                items: undefined
            };
            console.log(event);
            // event is ClipboardEvent
            // event.clipboardData // get clipboardData from browser event
            // event.originalEvent.clipboardData // if the event fired with delegate, like: jQuery
            let items, items_record;
            if (event instanceof ClipboardEvent) {
                this.$data.pasteData.prototype = event.__proto__.toString();
                if (event.clipboardData instanceof DataTransfer) {
                    items = event.clipboardData.items;
                    this.$data.pasteData.clipboardData = {
                        prototype: event.clipboardData.__proto__.toString()
                    };
                    if (items instanceof DataTransferItemList) {
                        this.$data.pasteData.clipboardData.items = {
                            prototype: items.__proto__.toString(),
                            length: items.length
                        };
                        // console.log(items.length)
                        for (let index in items) {
                            let item = items[index];
                            console.log(item, index, items, event.clipboardData.items);
                            if (item instanceof DataTransferItem) {
                                let sItem = {}, asFile = item.getAsFile(), asString,
                                    asStr = item.getAsString(str => {
                                        asString = str;
                                        console.log(asString, str);
                                    });
                                let asStrProm = new Promise((resolve, reject) => item.getAsString(str => resolve(str)));
                                // the asStr will always be undefined, since getAsString will return nothing.
                                // so if want handle the string result, must do in the call back
                                // a promise maybe will better
                                asStrProm.then(itemStr => {
                                    // will not update vue render.
                                });
                                sItem["prototype"] = item.__proto__.toString();
                                sItem['kind'] = item.kind; // only will be 'string' or 'file'
                                sItem['type'] = item.type; // mime-type
                                sItem['asFile'] = {
                                    prototype: asFile?.__proto__.toString(),
                                    content: asFile
                                };
                                sItem['asString'] = {
                                    prototype: asString?.__proto__.toString(),
                                    content: asString
                                };
                                sItem['asStr'] = asStr;
                                this.$data.pasteData.clipboardData.items[index] = sItem;
                                // console.log(index, items[index], asStr);
                            } else {
                                console.log(item);
                            }
                        }
                    }
                }
            }
            // refs: [Paste an image from clipboard using JavaScript](https://stackoverflow.com/questions/490908/)
            // let items = (event.clipboardData || event.originalEvent.clipboardData).items;
            // console.log(JSON.stringify(items)); // will give you the mime types
            // for (let index in items) {
            //     let item = items[index];
            //     if (item.kind === 'file') {
            //         let blob = item.getAsFile();
            //         let reader = new FileReader();
            //         reader.onload = function (event) {
            //             console.log(event.target.result)
            //         }; // data url!
            //         reader.readAsDataURL(blob);
            //     }
            // }
        }
    }
}
</script>
